module.exports = __webpack_public_path__ + "9788f41e/img/archive-icon.0a6a9de3.svg";